import { ArrowUpRight, ChefHat, Brain } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Reveal from "@/components/Reveal";

const fronts = [
  {
    num: "01",
    eyebrow: "Para restaurantes",
    Icon: ChefHat,
    title: "Do Custo",
    titleAccent: "ao Lucro",
    description:
      "Aplicação prática em gestão e precificação de restaurantes, dedicada exclusivamente ao setor de alimentação fora do lar. Transforma números em clareza e decisões em lucro sustentável.",
    cta: "Conhecer o Do Custo ao Lucro",
    href: "https://rodrigohaertel.com/do-custo-ao-lucro-home/",
  },
  {
    num: "02",
    eyebrow: "Para empreendedores",
    Icon: Brain,
    title: "Empretec",
    titleAccent: "2025",
    description:
      "Coautor da versão 2025 do Empretec — uma das principais metodologias de desenvolvimento do comportamento empreendedor no mundo, aplicada em dezenas de países.",
    cta: "Conhecer a atuação no Empretec",
    href: "/comportamento-empreendedor",
    internal: true,
  },
];

const Fronts = () => {
  return (
    <div className="grid gap-6 md:grid-cols-2 md:gap-8">
      {fronts.map((f, i) => {
        const Icon = f.Icon;
        return (
          <Reveal as="article" key={f.num} delay={i * 120}>
            <div
              className="group relative h-full overflow-hidden rounded-3xl border border-border/60 bg-background/40 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-accent/50 hover:bg-background/70 hover:shadow-[0_30px_80px_-30px_hsl(var(--accent)/0.35)] md:p-10"
            >
              {/* big watermark number */}
              <span
                aria-hidden="true"
                className="watermark-num pointer-events-none absolute -right-4 -top-10 select-none text-[12rem] leading-none md:-right-6 md:-top-12 md:text-[16rem]"
              >
                {f.num}
              </span>

              {/* subtle gradient on hover */}
              <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 bg-gradient-to-br from-accent/0 via-transparent to-accent/0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                style={{
                  background:
                    "radial-gradient(60% 80% at 100% 0%, hsl(var(--accent) / 0.10), transparent 70%)",
                }}
              />

              <div className="relative">
                <div className="mb-6 flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-accent/30 bg-accent/5 text-accent transition-all duration-500 group-hover:scale-110 group-hover:border-accent/60 group-hover:bg-accent/10">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <span className="rounded-full border border-border/70 bg-background-warm/60 px-3 py-1 text-[0.7rem] uppercase tracking-[0.2em] text-muted-foreground">
                    {f.eyebrow}
                  </span>
                </div>

                <h3 className="font-serif text-4xl font-light leading-[1.05] text-foreground md:text-5xl">
                  {f.title}{" "}
                  <span className="italic text-accent">{f.titleAccent}</span>
                </h3>

                <p className="mt-5 max-w-md text-base leading-relaxed text-muted-foreground md:text-lg">
                  {f.description}
                </p>

                <Button
                  asChild
                  className="mt-8 rounded-full bg-accent px-6 py-5 text-sm text-accent-foreground transition-all hover:bg-accent/90 hover:shadow-[0_8px_30px_-10px_hsl(var(--accent)/0.6)]"
                >
                  {(f as { internal?: boolean }).internal ? (
                    <Link to={f.href}>
                      {f.cta}
                      <ArrowUpRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                  ) : (
                    <a href={f.href} target="_blank" rel="noopener noreferrer">
                      {f.cta}
                      <ArrowUpRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </a>
                  )}
                </Button>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
};

export default Fronts;
